import ColoredWhatsappIcon from "@/components/icons/ColoredWhatsappIcon";
import useShowOnScroll from "@/hooks/useShowOnScroll";
import Link from "next/link";

const FloatingWhatsapp = () => {
  const { isShowOnScroll } = useShowOnScroll(20);

  return (
    <Link
      href="https://wa.me/9668002440277"
      className={`fixed bottom-16 max-sm:bottom-20 right-8 max-sm:right-4 z-[350] ${
        isShowOnScroll ? "visible" : "invisible"
      }`}
    >
      <ColoredWhatsappIcon width={50} height={50} />
    </Link>
  );
};

export default FloatingWhatsapp;
